module.exports = __webpack_public_path__ + "static/img/total_volume.b8b9cbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/total_volume.png
// module id = DAok
// module chunks = 0